import React from "react";

const GenContext = React.createContext()

export default GenContext;